import type { FeatureComponent, FeatureConfigInput, FeatureModule } from './types';
import { normalizeFeatureConfig } from './types';

export function createFeatureModule(
  configInput: FeatureConfigInput,
  component: FeatureComponent,
  sourceLabel: string
): FeatureModule {
  return {
    config: normalizeFeatureConfig(configInput, sourceLabel),
    Component: component
  };
}
